module.exports = __webpack_public_path__ + "static/ruche-032fec41b1c7e579fa32fa73017b24dc.jpg";